module.exports = __webpack_public_path__ + "img/status-error.aa5408b2.svg";